import { useMemo } from 'react';

import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import { KizenTypography } from '__app/typography';
import { checkRedirectDomain } from 'utility/redirectDomain';

const MessageWrapper = styled.div`
  padding-top: 15px;
  > .button-wrapper {
    padding-top: 5px;
  }
`;

export const RedirectMesage = () => {
  const { t } = useTranslation();

  const [redirectHostname, redirectUrl] = useMemo(
    () => checkRedirectDomain(),
    []
  );

  return redirectHostname ? (
    <MessageWrapper>
      <KizenTypography>
        {t('It looks like you usually use ‘{{redirectHostname}}’.', {
          redirectHostname,
        })}
      </KizenTypography>
      <div className="button-wrapper">
        <KizenTypography
          type="anchor"
          href={`https://${redirectUrl}`}
          target="_blank"
          rel="noreferrer"
        >
          {t('Go there instead.')}
        </KizenTypography>
      </div>
    </MessageWrapper>
  ) : null;
};
